var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative inline-block group"},[_vm._t("dropdown"),_c('div',{staticClass:"absolute hidden w-min h-content right-0 z-10 bg-white shadow rounded group-hover:block overflow-hidden"},[_vm._t("dropdown-content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }